import React from "react";
const IconAlertRed = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="16" height="16" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 3.4a4.6 4.6 0 1 0 0 9.2 4.6 4.6 0 0 0 0-9.2ZM1.4 8a6.6 6.6 0 1 1 13.2 0A6.6 6.6 0 0 1 1.4 8ZM8 9.4a1 1 0 0 1 1 1v.04a1 1 0 1 1-2 0v-.04a1 1 0 0 1 1-1ZM7 4.8v4h2v-4H7Z"
      fill="#CC0C0C"
    />
  </svg>
);
export default IconAlertRed;
